module.exports = __webpack_public_path__ + "media/Camille Saint-Saens - Danse Macabre.d699e3fa.mp3";